import React from 'react';
import { shopApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function Orders() {
  const { data: orders, loading, error, reload } = useApiData(() => shopApi.listMyOrders());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Orders</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={orders?.length === 0} emptyLabel="You haven't placed any orders yet.">
        <div className="space-y-3">
          {orders?.map((o) => (
            <div key={o.id} className="glass rounded-xl p-4 flex items-center justify-between">
              <div>
                <p className="font-medium">Order #{o.id.slice(-8)}</p>
                <p className="text-white/40 text-xs mt-0.5">{o.items?.length || 0} item(s) · {new Date(o.created_at).toLocaleDateString()}</p>
              </div>
              <div className="text-right">
                <p className="font-semibold">{o.currency} {o.total}</p>
                <span className="text-xs text-white/50 capitalize">{o.status}</span>
              </div>
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
